import { ApolloLink } from '@apollo/client';

export enum RecaptchaSupportedVersions {
  V2 = 2,
  // eslint-disable-next-line no-magic-numbers
  V3 = 3,
}

export const createRecaptchaLink = (versionNumber: RecaptchaSupportedVersions) =>
  new ApolloLink((operation, forward) => {
    const recaptchaToken = sessionStorage.getItem(`recaptchaV${versionNumber}Token`);
    if (!recaptchaToken) {
      return forward(operation);
    }

    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        [`x-recaptcha-v${versionNumber}-token`]: recaptchaToken,
      },
    }));
    sessionStorage.removeItem(`recaptchaV${versionNumber}Token`);
    return forward(operation);
  });
